import React from "react";
import { Phone, MessageCircle } from "lucide-react";
import { SITE } from "../data/site";

export const FloatingActions = () => {
    const wa = SITE.whatsapp.replace(/\D/g, "");
    return (
        <div className="fixed bottom-5 right-5 z-40 flex flex-col gap-3">
            <a
                data-testid="float-whatsapp"
                href={`https://wa.me/${wa}?text=${encodeURIComponent(
                    "Hi Design Desire, I'd like to know more about your services."
                )}`}
                target="_blank"
                rel="noreferrer"
                className="w-12 h-12 md:w-14 md:h-14 bg-[#25D366] hover:bg-[#1ebe5d] text-white flex items-center justify-center shadow-lg transition-transform hover:-translate-y-0.5"
                aria-label="WhatsApp"
                title="Chat on WhatsApp"
            >
                <MessageCircle size={20} strokeWidth={1.6} />
            </a>
            <a
                data-testid="float-call"
                href={`tel:${SITE.phones[0].replace(/\s/g, "")}`}
                className="w-12 h-12 md:w-14 md:h-14 bg-[#1A1A1A] hover:bg-[#2A2421] text-[#FAF9F6] flex items-center justify-center shadow-lg transition-transform hover:-translate-y-0.5"
                aria-label="Call"
                title="Call us"
            >
                <Phone size={18} strokeWidth={1.6} />
            </a>
        </div>
    );
};
